export class LT {
  getOptions() {
    return {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
  }
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/core/i18n/date/Time.js
 **/